/* External */
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { List } from 'immutable';

/* Storage */
import { selectMultiplePolymorphicEntities } from '../storage/selectors';

/* Utils */
import createCachedListSelectorHook from './createCachedListSelectorHook';

function useCarouselContentsFunc(carousel) {
  const contents = carousel?.contents;
  const sectionItemsSelector = useMemo(
    () => selectMultiplePolymorphicEntities(contents),
    [contents],
  );

  return useSelector(sectionItemsSelector) || List();
}

const useCarouselContents = createCachedListSelectorHook(useCarouselContentsFunc);

export default useCarouselContents;
